module.exports = __webpack_public_path__ + "img/homepage-quick-links-infiniti.200ddb3c.jpg";